<template>
    <v-dialog v-model="dialog" max-width="800px">
        <v-card>
            <title-dialog :title="'Transferir Insumo'" @close="dialog = false" />
            <v-card-text>
                <v-row>
                    <v-col>
                                                <v-text-field
                                                    dense
                                                    rounded
                                                    outlined
                                                    v-model="search"
                                                    label="Pesquisar"
                                                    :error-messages="search.length > 0 && search.length < 3 ? 'Digite no mínimo 3 caracteres' : ''"
                                                ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-chip color="primary">selecionado: {{ countItems }}</v-chip>
                    </v-col>
                </v-row>
                <v-card outlined :disabled="loadingTable">

                <v-data-table
                :loading="loadingTable"
                show-select
                v-model="selected"
                :items="items"
                :headers="headers"
                dense
                :pageCount="numberOfPagesPaginate"
                :page="currentPagePaginate"
                :server-items-length="totalStagesPaginate"
                :options.sync="options"
                :footer-props="{
                    itemsPerPageText: 'Itens por pagina',
                    itemsPerPageOptions:[5,10,15],
                    showFirstLastPage:true
                }"
                >
                    <template v-slot:item.code="{ item }">
                         {{item.input_group.code +'-'+ item.full_code }}
                    </template>
                </v-data-table>
                </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  class="mx-0 mt-3 mr-1"
                  large
                  @click="dialog = false"
                >
                   Fechar
                  </v-btn>
                <v-btn
                @click="transfer"
                 large
                class="primary mx-0 mt-3"
                :loading="btnLoadingSave"
                :disabled="btnLoadingSave"

                >Transferir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import TitleDialog from "@/pages/Components/TitleDialog.vue";
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        TitleDialog
    },
    props: {
        value: Boolean,
    },

    data() {
        return {
            totalStagesPaginate: 0,
            numberOfPagesPaginate: 0,
            currentPagePaginate: 1,
            options: {},
            loadingTable : false,
            dialog: false,
            search: '',
            items: [],
            selected: [],
            headers: [
                { text: "CODIGO", width:150 ,align: "start", sortable: false, value: "code" },
                { text: "NOME", value: "name" },
                { text: "", align: "end", value: "actions", sortable: false, },
            ],
        }
    },
    computed: {
        ...mapGetters('InputGroup',['getInputGroupId']),
        countItems() {
            return this.selected.length;
        }
    },
    watch: {
        options: {
      handler() {
        this.initialize();
      },
    },
        dialog(val) {
            val || this.$emit('input', false);
        },
        value(val) {
            this.dialog = val;
            if(val) {
                this.search = '';
                this.selected = [];
                this.items = [];
                this.initialize();
            }
        },
        search() {
            this.initialize();
        }
    },
    methods: {
        ...mapActions('Input', ['getInputsTranfer', 'transferInput']),
      initialize() {
        if( this.search.length > 0){
            if(this.search.length < 3) {
            return;
        }
        }

        const { page, itemsPerPage } = this.options;

this.loadingTable = true;
        let payload = {
            search: this.search,
            page: page||1,
            itemsPerPage: itemsPerPage || 10
        }
        this.getInputsTranfer(payload).then((response) => {
            this.items = response.data.data;
            this.totalStagesPaginate = response.data.total
           this.numberOfPagesPaginate = response.data.last_page
           this.currentPagePaginate = response.data.current_page
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            this.loadingTable = false;
        });
      },
      transfer() {
        let data = {
            new_input_group_id: this.getInputGroupId,
            inputs: this.selected.map(item => item.id)
        }
        this.btnLoadingSave = true;
        this.transferInput(data).then(()=>{
            this.$emit('confirm');
            this.$toast.success('Insumos transferidos!');
            this.dialog = false;
        })
        .catch((error) => {
            console.log(error);
        }).finally(() => {
            this.btnLoadingSave = false;
        });

      },

    },
}
</script>
